import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function StatCard({
  label,
  value,
  hint,
  className,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-line bg-bg-card/40 p-5 flex flex-col gap-1",
        className,
      )}
    >
      <span className="text-xs uppercase tracking-[0.18em] text-ink-dim">{label}</span>
      <span className="text-2xl font-semibold text-ink">{value}</span>
      {hint ? <span className="text-xs text-ink-dim">{hint}</span> : null}
    </div>
  );
}
